(function() {
    'use strict';

    angular.module('swif.publicLightning')
    .config(['$routeProvider', 'swifPublicLightningConstant', function($routeProvider, constants) {
        $routeProvider.when(constants.configuration.routes.configuration_view, {
            templateUrl: 'partials/public-lightning/configuration_view.html',
            controller: 'PublicLightningConfigurationController',
            reloadOnSearch: false
        })
    }])

    .controller('PublicLightningConfigurationController', function($scope, swifFrameworkService) {
        'ngInject';
        console.log('init PublicLightningConfigurationController');

        const swif = swifFrameworkService;
        swif.settings.page.title = 'Public lightning module configuration';

        // TODO: everything

        $scope.refresh = function() {

        }
    });
})();
